import React, { useState } from 'react';
import { Box, ListItem, ListItemText, Checkbox, TextField } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import {
  CheckBox as CheckBoxIcon,
  CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
} from '@mui/icons-material';
import FilterComponent from './FilterComponent';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const CitySelectorFilter = ({ label, cities, value, handleChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const options = (cities || []).map(city => ({ name: city }));
  const values = (value || []).map(value => ({ name: value }));

  const getLabel = () => {
    if (values.length === 0 || values.length === cities.length) {
      return `${label}: all`;
    }

    return `${label}: ${values.length} selected`;
  };

  return (
    <>
      <ListItem button onClick={() => setIsOpen(!isOpen)}>
        <ListItemText primary={getLabel(value)} />

        {isOpen ? <ExpandMoreIcon /> : <ExpandLessIcon />}
      </ListItem>

      <FilterComponent isOpen={isOpen}>
        <Box flexGrow={1} display="flex" flexDirection="column">
          <Autocomplete
            open
            onClose={() => {}}
            value={values}
            onChange={(event, newValue) => handleChange((newValue || []).filter(city => !!city).map(city => {
              if (typeof city === 'string') {
                return city;
              }

              return city.name;
            }))}
            multiple
            sx={{
              width: '100%',
              padding: '5px 15px',
            }}
            slotProps={{
              paper: {
                sx: {
                  boxShadow: 'none',
                  margin: 0,
                  color: '#586069',
                  fontSize: 13,
                  width: '100%',
                  transform: 'none',
                },
              },
              popper: {
                disablePortal: true,
                sx: {
                  position: 'relative !important',
                  width: '100% !important',
                  transform: 'none !important',
                  inset: 'unset !important',
                  zIndex: 2,
                },
              },
            }}
            disableCloseOnSelect
            disablePortal
            renderTags={() => null}
            noOptionsText="No labels"
            isOptionEqualToValue={(option, value) => option.name === value.name}
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  color="secondary"
                  checked={selected}
                />
                {option.name}
              </li>
            )}
            options={options}
            getOptionLabel={option => option.name}
            renderInput={params => (
              <TextField variant="outlined" fullWidth ref={params.InputProps.ref} inputProps={params.inputProps} />
            )}
          />
        </Box>
      </FilterComponent>
    </>
  );
};

export default CitySelectorFilter;
